<template>
  <DefImg :result="result" />
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';

export default {
  name: 'CatalogPageTopBanner',
  components: { DefImg },
  props: {
    result: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped></style>
